import { render } from "./AddObjectStorage.vue?vue&type=template&id=7a7ae566&scoped=true"
import script from "./AddObjectStorage.vue?vue&type=script&lang=js"
export * from "./AddObjectStorage.vue?vue&type=script&lang=js"

import "./AddObjectStorage.vue?vue&type=style&index=0&id=7a7ae566&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7ae566"]])

export default __exports__